import { api } from './customers'

export interface CustomerContact {
    id: number
    customerId: string
    phone1: string
    phone2: string
    email1: string
    email2: string
    city: string
    area: string
    status: string
}

type CustomerContactsResponse = CustomerContact[]


export const customerContactApi = api.injectEndpoints({
    endpoints: (build) => ({
        getCustomerContacts: build.query<CustomerContactsResponse, void>({
            query: () => 'customer_contact',
            providesTags: (result) =>
                result
                    ? [
                        ...result["data"]?.map(({ id }) => ({ type: 'CustomerContact' as const, id })),
                        { type: 'CustomerContact', id: 'LIST' },
                    ]
                    : [{ type: 'CustomerContact', id: 'LIST' }],
        }),
        addCustomerContact: build.mutation<CustomerContact, Partial<CustomerContact>>({
            query: (body) => ({
                url: `customer_contact`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: CustomerContact }, meta, arg) => response.data,
        }),
        getCustomerContact: build.query<CustomerContact, string>({
            query: (id) => `get_customercontactBycustomerID/${id}`,
            transformResponse: (response: { data: CustomerContact }, meta, arg) => response.data,
        }),
        updateCustomerContact: build.mutation<void, Pick<CustomerContact, 'id'> & Partial<CustomerContact>>({
            query: ({ id, ...patch }) => ({
                url: `customer_contact/${id}`,
                method: 'PUT',
                body: patch,
            }),
        }),
        deleteCustomerContact: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `customer_contact/${id}`,
                    method: 'DELETE',
                }
            },
        }),
    }),
})

export const {
    useGetCustomerContactQuery,
    useGetCustomerContactsQuery,
    useAddCustomerContactMutation,
    useUpdateCustomerContactMutation,
    useDeleteCustomerContactMutation,
} = customerContactApi

